import script from "./MobActions.vue?vue&type=script&setup=true&lang=js"
export * from "./MobActions.vue?vue&type=script&setup=true&lang=js"

import "./MobActions.vue?vue&type=style&index=0&id=5ed31684&lang=css"

const __exports__ = script;

export default __exports__